const BankExpansionSkeleton = () => {
  return (
    <div className="gx-custom-expansion-panel w-full">
      <div className="gx-bank-header !flex !items-center !justify-between animate-pulse">
        <div className="gx-bank-info !flex !items-center !gap-x-3">
          {/* Logo */}
          <div className="!w-[40px] !h-[40px] rounded-full bg-gray-300" />

          {/* Bank name */}
          <div className="h-4 w-32 rounded bg-gray-300" />
        </div>

        {/* Chevron */}
        <div className="h-4 w-4 rounded bg-gray-300" />
      </div>
    </div>
  );
};

export default BankExpansionSkeleton;
